<template>
  <div>
    <FormKit
     type="form"
      @submit="submitHandler"
      :actions="false"
      #default="{ value }"
      :value="true"
      allow-incomplete="true"
    >
      <FormKit type="multi-step" name="multi-step_2" tab-style="tab" >
        <FormKit type="step" id="prototype"  name="prototype" :nextLabel="'Suivant'">
          <Step0 />
        </FormKit>
  
        <FormKit type="step" name="Informations produit" :previousLabel="'Précédent'"  :nextLabel="'Suivant'">
          <Step2 />
        </FormKit>

        <FormKit type="step" name="catégories" :previousLabel="'Précédent'"  :nextLabel="'Suivant'">
          <Step3 />
        </FormKit>
        <FormKit type="step" label= "Images & Descriptions" name="ImagesAndDescriptions" :previousLabel="'Précédent'" :nextLabel="'Suivant'">
          <Step4 :descriptions="descriptions" :images="images" ref="stepFour" />
          <template #stepNext>
            <FormKit type="submit" label="Créer" />
          </template>
        </FormKit>
        


    </FormKit>
  </FormKit>
</div>
</template>

<script setup lang="ts">


import Step0 from '@/components/product/masterProduct/create/PrototypeStep.vue'                
import Step2 from '@/components/product/masterProduct/create/InformationStep.vue'
import Step3 from '@/components/product/masterProduct/create/CategoriesStep.vue'
import Step4 from '@/components/product/masterProduct/create/DescriptionImageStep.vue'

import { useProductStore } from '@/stores/product/prototypeStore'
import { ref, reactive, computed } from 'vue'
import ApiService from "@/_services/api.service";
import Swal from "@/_helpers/swal";
import ListProducts from "./ListProducts.vue"
import router from "@/router";
import {getCountryNameByCode} from "@/_services/geolocation/country";

/*
  I think the product will be initialized in this page (or get if it is an update)
  descriptions will be equal to the descriptions of the product, here I set a default value to it to check if it works with a default value (for an upddate)
  
  The same goes for images

  To test the delete, you must add a description with an existing uuid in the database, the descriptions images will be empty since they were handled by the wysiwyg
*/
const descriptions = reactive([]);
const images = reactive([]);
const stepFour = ref();

const submitted = ref(false)
const submitHandler = async (data) => {
  try {
    const selectedPrototype = data['multi-step_2']['prototype']['prototype'];
    const prototypeActions = {
      '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f': { func: submitETicket, message: 'Vous venez de créer un produit E-billet' },
      '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f': { func: submitPhysicalProduct, message: 'Vous venez de créer un produit physique' },
      '6a3fe435-fdfd-11ed-a0b1-de1c3c38600f': { func: submitGiftCard, message: 'Vous venez de créer un produit carte cadeau' },
      '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f': { func: submitPromotionCode, message: 'Vous venez de créer une Redirection sur site partenaire / Codes promo' },
      '6a401dea-fdfd-11ed-a0b1-de1c3c38600f': { func: submitProductMember, message: 'Vous venez de créer une carte de membre' },
    };

    const action = prototypeActions[selectedPrototype];
    if (action) {
      const productInfo = await action.func(data);
      showSwal(action.message, selectedPrototype, productInfo);
    }
    await router.push({ name: 'ListProducts' });
  } catch (error) {
    console.error(error);
    Swal.error('An error occurred catch');
  }
};

const showSwal = (message, prototype, productInfo) => {
  Swal.success('', message).then(() => {
    const isCodeOrMemberCard = ['6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f', '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'].includes(prototype);

    if (!isCodeOrMemberCard) {
      Swal.confirm('Souhaitez-vous créer des variants pour ce produit ?', 'Non', 'Oui').then((result) => {
        if (result.isConfirmed) {
          router.push({ name: 'customAddAttribut' , params: { uuid: productInfo.uuid }});
        }
      });
    }
  });
};

  const productStore = useProductStore();

  const invokeGetProductPrototype = () => {
    productStore.getProductPrototype();
  };

  invokeGetProductPrototype()

  const productPrototype = computed(() => productStore.getProductPrototype());

const generateCommonPayload = (data) => {
  return {
    prototype: data['multi-step_2']['prototype']['prototype'],
    mainInformationsBlock: {
      reference: data['multi-step_2']['Informations produit']['reference'],
      brand: {
        name: data['multi-step_2']['Informations produit']['brand']['name'],
        uuid: data['multi-step_2']['Informations produit']['brand']['uuid'],
      },
      productName: data['multi-step_2']['Informations produit']['productName'],
      adminProductName: data['multi-step_2']['Informations produit']['adminProductName'],
      shortDescription: data['multi-step_2']['Informations produit']['shortDescription'],
      urssafClassification: [data['multi-step_2']['Informations produit']['urssafClassification']],
      urssafEvent: data['multi-step_2']['Informations produit']['urssafEvent'],
      socialEvent: data['multi-step_2']['Informations produit']['socialEvent'],
    },
    statusBlock: {
      //status: data['multi-step_2']['Informations produit']['statusBlock'],
      activationDate: data['multi-step_2']['Informations produit']['enableDate'],
      disabledDate: data['multi-step_2']['Informations produit']['disableDate'],
      saleClosingReason: data['multi-step_2']['Informations produit']['saleClosingReason'],
      active: data['multi-step_2']['Informations produit']['active'] ? 1 : 0,
      hiddenProduct: data['multi-step_2']['Informations produit']['hiddenProduct'] ? 1 : 0,
      closedSale: data['multi-step_2']['Informations produit']['closedSale'] ? 1 : 0,
    },
    redirectionLink: data['multi-step_2']['Informations produit']['redirectionLink'],
    descriptions: data['multi-step_2']['ImagesAndDescriptions']['descriptionListUuid'],
    images: getImagesUuid(data['multi-step_2']['ImagesAndDescriptions']['images']),
    categories: Object.keys(data['multi-step_2']['catégories']),
    specialProperty: data['multi-step_2']['Informations produit']['specialProperty'],
    supplierBlock: {
      supplier: data['multi-step_2']['Informations produit']['supplier'],
      shippingMethod: data['multi-step_2']['Informations produit']['shippingMethod'],
      delayedSending: data['multi-step_2']['Informations produit']['delayedSending'],
    },
    stockBlock: {
      stock: parseInt(data['multi-step_2']['Informations produit']['stock']),
      limitByCart: parseInt(data['multi-step_2']['Informations produit']['limitByCart']),
      limitByUser: parseInt(data['multi-step_2']['Informations produit']['limitByUser']),
      stockAlertThreshold: parseInt(data['multi-step_2']['Informations produit']['stockAlertThreshold']),
    },
    pricingBlock: {
      price: parseFloat(data['multi-step_2']['Informations produit']['price']),
      tax: data['multi-step_2']['Informations produit']['tax'],
      reductionType: data['multi-step_2']['Informations produit']['reductionType'] ?? data['multi-step_2']['Informations produit']['reductionTypeAsReduction'],
      publicPrice: parseFloat(data['multi-step_2']['Informations produit']['publicPrice']),
      reductionValue:  data['multi-step_2']['Informations produit']['reductionValue'],
      reductionDescription:  data['multi-step_2']['Informations produit']['reductionDescription'], 
      purchasingPrice: data['multi-step_2']['Informations produit']['purchasingPrice'],
      country: 'FR',
    },
    usageConditionBlock: {
      onlineValidity: data['multi-step_2']['Informations produit']['usableOnline'],
      offlineValidity: data['multi-step_2']['Informations produit']['usableInStore'],
      driveValidity: data['multi-step_2']['Informations produit']['usableInDrive'],
    },
    promotionCodeBlock: {
      webPromoCode: data['multi-step_2']['Informations produit']['webPromoCode'],
      phonePromoCode: data['multi-step_2']['Informations produit']['codePromoPhone'],
      phoneNumber: data['multi-step_2']['Informations produit']['phone'],
      callPrice: data['multi-step_2']['Informations produit']['callPrice']
    },
    promotionIdentificationBlock: {
      login: data['multi-step_2']['Informations produit']['identifiant'],
      password: data['multi-step_2']['Informations produit']['password'],
    },
    geolocations: prepareGeolocation(data)
  }
}

const submitPhysicalProduct = async (data) => {
  const selectedPrototype = data['multi-step_2']['prototype']['prototype'];
  delete data['multi-step_2']['catégories']["hasSelectedCategory"]
  const payload = generateCommonPayload(data);
    payload.prototype = selectedPrototype;
  const response = await ApiService.post('master-product-physical', payload);
  return response.data.data;
}

const submitETicket = async (data) => {
  const selectedPrototype = data['multi-step_2']['prototype']['prototype'];
  delete data['multi-step_2']['catégories']["hasSelectedCategory"]
  const payload = generateCommonPayload(data);
  payload.prototype = selectedPrototype;
  const response = await ApiService.post('master-product-e-ticket', payload);
  return response.data.data;
}

const submitGiftCard = async (data) => {
  const selectedPrototype = data['multi-step_2']['prototype']['prototype'];
  delete data['multi-step_2']['catégories']["hasSelectedCategory"]
  const payload = generateCommonPayload(data);
  payload.prototype = selectedPrototype;
  const response = await ApiService.post('master-product-gift-card', payload);
  return response.data.data;
}

const submitProductMember = async (data) => {
  const selectedPrototype = data['multi-step_2']['prototype']['prototype'];
  delete data['multi-step_2']['catégories']["hasSelectedCategory"]
  const payload = generateCommonPayload(data);
  payload.prototype = selectedPrototype;
  await ApiService.post('master-product-member-card', payload);
};

const submitPromotionCode = async (data) => {
  const selectedPrototype = data['multi-step_2']['prototype']['prototype'];
  delete data['multi-step_2']['catégories']["hasSelectedCategory"]
  const payload = generateCommonPayload(data);
  payload.prototype = selectedPrototype;
  await ApiService.post('master-product-promotion-code', payload);
};

function prepareGeolocation(data) {
  let geolocations: any = [];
  const type = data['multi-step_2']['Informations produit']['geolocationType'];
  const apiKey = data['multi-step_2']['Informations produit']['geolocationApiKey'];
  const addresses: any = data['multi-step_2']['Informations produit']['geolocationAddresses'];
  if (apiKey) {
    geolocations.push({
      type: type,
      apiKey: apiKey
    })
  } else if (addresses) {
    addresses.forEach((address) => {
        let dataGeolocation = {
            type: type,
            method: address.manualMethod
        };

        if ('address' === address.manualMethod || 'completed_by_partner' === address.manualMethod) {
            const countryCode = address.country;
            const countryName = getCountryNameByCode(countryCode);

            dataGeolocation.address = address.address;
            dataGeolocation.zipCode = address.zipCode;
            dataGeolocation.city = address.city;
            dataGeolocation.country = countryName;
            dataGeolocation.countryCode = countryCode;
        }
        
        if ('geocoding' === address.manualMethod || 'completed_by_partner' === address.manualMethod) {
            dataGeolocation.longitude = parseFloat(address.longitude);
            dataGeolocation.latitude = parseFloat(address.latitude);
        }

        if ('completed_by_partner' === address.manualMethod) {
            dataGeolocation.formattedAddress = address.formattedAddress;
        }
        
        geolocations.push(dataGeolocation);
    });
  } else {
    geolocations.push({
      type: type,
    })
  }
  return geolocations;
}
function getImagesUuid(imagesArray) {
  const imagesUuids = imagesArray.reduce((accumulator, image) => {
    if (image.uuid) {
      accumulator.push(image.uuid);
    }
    return accumulator;
  }, []);
  return imagesUuids;
}


</script>

<style lang="scss">
  .formkit-form{
      .formkit-outer[data-type='multi-step']{
          .formkit-wrapper{
              max-width: 1200px;
              width: 100%;
              margin: auto;
              .formkit-fieldset{
                display: inline-block;
              }
          }
      }
  }
</style>